let baseAPI = localStorage.getItem('baseAPI')

if (!baseAPI) baseAPI = 'https://pruvo-puz47b2qwq-rj.a.run.app/api'
// if (!baseAPI) baseAPI = 'https://test-api.pruvo.app/api'

export default baseAPI
